import React, { FC } from "react";
import {
  Button,
  Row,
  Col,
} from "antd";
import { ReactSVG } from "react-svg";

const PersonItem: FC<{
    userObj?: any;
    avatar: string;
    onClick: () => void;
  }> = ({ avatar, onClick, userObj }) => (
    <Row className="person-item d-flex">
      <Col onClick={onClick}>
        <img width="40" style={{ cursor: "pointer" }} src={avatar} />
      </Col>
      <Col span={14}>
        <h5>
          {userObj?.firstName} {userObj.lastName}
        </h5>
        <p>Email: {userObj?.email ?? "N/A"}</p>
        <p>Phone: {userObj?.phone ?? "N/A"}</p>
      </Col>
      <Col>
        <Button className="beam-btn icon-btn">
          <ReactSVG
            src="/images/flag-icon.svg"
            className={`${
              userObj?.nonpersistent?.static?.live?.status?.name ?? "gray"
            }-icon`}
          />
        </Button>
      </Col>
    </Row>
  );

  export default PersonItem;